import React from "react";

/**
 * VideoBlock — autoplay, muted, loop, playsinline.
 * Premium gradient fallback always behind the video.
 *
 * Props:
 *  - src: string (mp4 URL)
 *  - className: extra classes for outer wrap
 *  - aspect: tailwind aspect class (default "aspect-video")
 *  - overlay: boolean — adds a darker overlay for text legibility
 *  - poster: optional poster image URL
 *  - testId: data-testid for the wrapper
 *  - variant: "boxed" (rounded card w/ shadow) | "blend" (no border, mask-feathered into bg)
 */
const VideoBlock = ({
  src,
  className = "",
  aspect = "aspect-video",
  overlay = false,
  poster,
  testId,
  variant = "boxed",
}) => {
  const wrapClass = variant === "blend" ? "et-video-blend" : "et-video-wrap";
  return (
    <div
      data-testid={testId}
      className={`${wrapClass} et-grain ${aspect} ${className}`}
    >
      {/* Premium gradient fallback (always behind) */}
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(circle at 30% 20%, rgba(197,160,89,0.22), transparent 55%), radial-gradient(circle at 80% 80%, rgba(19,40,61,0.85), transparent 60%), linear-gradient(135deg, #10202e 0%, #13283d 100%)",
        }}
      />

      <video
        src={src}
        poster={poster}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        className="relative z-10 w-full h-full object-cover"
      />

      {overlay && (
        <div
          aria-hidden
          className="absolute inset-0 z-20 pointer-events-none"
          style={{
            background:
              "linear-gradient(180deg, rgba(16,32,46,0.55) 0%, rgba(16,32,46,0.35) 40%, rgba(16,32,46,0.75) 100%)",
          }}
        />
      )}
    </div>
  );
};

export default VideoBlock;
